export default __webpack_public_path__ + "img/_/_/views/cabinet/utils/components/ChangeLanguage/assets/images/kz.png";